import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { UserService } from './services/userService/user.service';

@Injectable({
    providedIn: 'root'
})
export class GuestAuthGuard implements CanActivate {
    constructor(private userService: UserService) { }
    canActivate() {
        if (this.userService.isLoggedIn() == false) {
            return true;
        }
        location.hash = "#/home";
        return false;
    }
}